import { Box, Drawer, useMediaQuery } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { setFluidLayout } from "../../../util/fluid-layout";
import { AdminSideNav } from "../../common/admin-side-nav/admin-side-nav";
import { AdminTopNav } from "../../common/admin-top-nav/admin-top-nav";

export interface IAdminLayoutProps {
  children: React.ReactNode;
}

export const AdminLayout: FC<IAdminLayoutProps> = ({ children }) => {
  // Below 1200px the menu slides in from the left instead of taking room
  const wide = useMediaQuery("(min-width:1200px)");
  const [menuOpen, setMenuOpen] = useState(false);

  // The admin fills the window at any size instead of the POS's 16:9 frame
  useEffect(() => {
    setFluidLayout(true);
    return () => setFluidLayout(false);
  }, []);

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        backgroundColor: "#F7F7F7",
        fontFamily: "var(--font-sans)",
      }}
    >
      {wide ? (
        <AdminSideNav />
      ) : (
        <Drawer
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
          ModalProps={{ keepMounted: true }}
          PaperProps={{ sx: { maxWidth: "85vw", border: "none" } }}
        >
          <AdminSideNav onNavigate={() => setMenuOpen(false)} />
        </Drawer>
      )}
      <Box component="main" sx={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <AdminTopNav showMenuButton={!wide} onMenuClick={() => setMenuOpen(true)} />
        <Box sx={{ flex: 1, minHeight: 0, p: { xs: "0.85rem", md: "1.35rem" } }}>
          <Box
            component="section"
            aria-label="Page content"
            sx={{
              height: "100%",
              overflow: "auto",
              p: { xs: "1.2rem", md: "2rem" },
              backgroundColor: "#ffffff",
              border: "1px solid #E5E7EB",
              borderRadius: "1.35rem",
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            }}
          >
            {children}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
